import { useCallback } from "react"
import { API_ENDPOINTS } from "../../../api/endpoints"
import { useApi } from "../../../hooks/useApi"

export const useChangeAuth0UserState = () => {
  const api = useApi()

  return useCallback(
    (auth0UserId: string, userBlock: boolean | undefined): Promise<unknown> => {
      const encodedUserId = encodeURIComponent(auth0UserId).replaceAll(
        "|",
        "%7C",
      )
      return api.patch(
        `${API_ENDPOINTS.BASE}auth0/users/${encodedUserId}/block`,
        { blocked: userBlock },
        { errorMessage: "Error al actualizar el estado del usuario" },
      )
    },
    [api],
  )
}
